/* eslint-disable no-unused-vars */
/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useState } from 'react'
import { jsx, Box, Text, Image } from 'theme-ui'
import ReactPlayer from 'react-player/lazy'

import SwiperCore, { Virtual, Pagination, EffectFade } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/virtual'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import styles from './styles.js'

SwiperCore.use([Pagination, EffectFade, Virtual])

const ParnershipVideos = ({
  videos,
  videoTitle,
  isMobile,
  onClickVideo,
  setVideoProgress,
  onVideoEnded,
  onVideoPause,
}) => {
  const [videoDuration, setVideoDuration] = useState(0)
  const onVideoProgress = (progress) => {
    const viewSeconds = progress.playedSeconds
    const calculatePercentage = (viewSeconds * 100) / videoDuration
    setVideoProgress(calculatePercentage)
  }

  return (
    <Box sx={styles.container}>
      <Text as="h4" sx={styles.videoTitle}>
        {videoTitle}
      </Text>

      <Box sx={styles.sliderWrap}>
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          pagination={{ enabled: videos.length > 1, clickable: true }}
        >
          {videos &&
            videos.map((slide, index) => (
              <SwiperSlide
                key={`${index}-${slide.topTitle}`}
                virtualIndex={index}
              >
                {slide.video === '' && !slide.embedUrl ? (
                  <Image
                    sx={styles.carouselImage}
                    src={slide.thumbnail}
                    alt={slide.title}
                  />
                ) : (
                  <ReactPlayer
                    playsinline
                    playing
                    url={slide.video || slide.embedUrl}
                    style={{ borderRadius: '10px 10px 10px 0px' }}
                    controls={true}
                    width={isMobile ? '100%' : '550px'}
                    height={isMobile ? '180px' : '300px'}
                    onContextMenu={(e) => e.preventDefault()}
                    config={{
                      file: {
                        attributes: { controlsList: 'nodownload' },
                        forceAudio: true,
                        forceVideo: true,
                      },
                    }}
                    light={slide.thumbnail}
                    muted={false}
                    onDuration={setVideoDuration}
                    onProgress={onVideoProgress}
                    onEnded={onVideoEnded}
                    onPlay={onClickVideo}
                    onPause={onVideoPause}
                  />
                )}
              </SwiperSlide>
            ))}
        </Swiper>
      </Box>
    </Box>
  )
}
export default ParnershipVideos
